import { PreferencesTabs, type PreferencesTabsType } from '../Preferences';
import { Accordion, Form, InputGroup } from 'react-bootstrap';
import type { PreferencesTask } from '../../../../lib';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { useLoggedInUser } from '../../../../context';
import Swal from 'sweetalert2';

interface TasksSettingProps {
  tasks: PreferencesTask[];
  activeTab: PreferencesTabsType;
  onChangeTask: (name: string, value: boolean) => void;
  taskState: Record<string, boolean>;
}
const TasksSetting = ({
  onChangeTask,
  taskState,
  tasks,
  activeTab,
}: TasksSettingProps) => {
  const { clinics } = useSelector((state: RootState) => state.clinicianProfile);
  const { loggedInUser } = useLoggedInUser();
  const allTeams = clinics.filter(
    (clinic) => clinic.organisation_unit === 'team',
  );

  const allClinicianIdsInTeams = Array.from(
    new Set(
      allTeams.flatMap((team) =>
        team.caremapprClinicians?.map((clinician) => clinician.user_id || []),
      ),
    ),
  ).filter(Boolean) as number[];

  const isInAnyTeam = allClinicianIdsInTeams.includes(
    loggedInUser?.userId || 0,
  );
  const onClickCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isInAnyTeam) {
      Swal.fire({
        icon: 'warning',
        text: 'You are not in any teams. Please wait for a supervisor to add you to a team.',
        confirmButtonText: 'OK',
      });
      return;
    }
    onChangeTask(e.target.name, e.target.checked);
  };
  return (
    <Accordion.Item eventKey={PreferencesTabs.TASKS}>
      <Accordion.Header>
        <span className="d-flex align-items-center font-weight-600 gap-3">
          Tasks
        </span>

        {activeTab !== PreferencesTabs.TASKS ? (
          <i className="fa fa-plus" aria-hidden="true" />
        ) : (
          <i className="fa fa-minus" aria-hidden="true" />
        )}
      </Accordion.Header>
      <Accordion.Body>
        {tasks.length === 0 || !isInAnyTeam ? (
          <div className="text-center text-dark my-5">
            {!isInAnyTeam
              ? 'You are not in any teams. Please wait for a supervisor to add you to a team.'
              : 'The teams assigned to you do not have any tasks available.'}
          </div>
        ) : (
          <>
            <div className="list-information-header">
              Unselect any tasks not relevant to you
            </div>
            <Form className="list-information-options my-4 tags-container">
              {tasks.map((task, index) => (
                <InputGroup
                  className="mb-3 tag-item"
                  key={`task-setting-${index}`}
                >
                  <InputGroup.Checkbox
                    name={task.id}
                    checked={!!taskState[task.id]}
                    onChange={onClickCheckbox}
                  />
                  <span className="tagFullName">{task.task}</span>
                </InputGroup>
              ))}
            </Form>
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default TasksSetting;
